var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(-308 -12)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(308 12)",
    fill: "#00aec4",
    opacity: 0.997
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-friends",
    "data-name": "Icon awesome-user-friends",
    d: "M6.857,10.25a4,4,0,1,0-4-4A4,4,0,0,0,6.857,10.25ZM9.6,11.393H9.3a5.523,5.523,0,0,1-4.893,0h-.3A4.115,4.115,0,0,0,0,15.507v1.029A1.715,1.715,0,0,0,1.714,18.25H12a1.715,1.715,0,0,0,1.714-1.714V15.507A4.115,4.115,0,0,0,9.6,11.393Zm7.543-1.143a3.429,3.429,0,1,0-3.429-3.429A3.429,3.429,0,0,0,17.143,10.25Zm1.714,1.143h-.136a4.5,4.5,0,0,1-3.157,0h-.136a3.967,3.967,0,0,0-1.989.55,5.227,5.227,0,0,1,1.418,3.564v1.371c0,.079-.018.154-.021.229h6.307a1.715,1.715,0,0,0,1.714-1.714,4,4,0,0,0-4-4Z",
    transform: "translate(315 19.75)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSelected);
export default __webpack_public_path__ + "static/media/userSelected.a3c879ce5fa8cacb7c0fdd5d0a8a319c.svg";
export { ForwardRef as ReactComponent };